import { cn } from '../../utils/cn';
import { BorderBeam } from '../animations/border-beam';
import { Inline } from '../inline/inline';

type AiEnrichmentLoadingProps = {
  description: string;
};

export const AiEnrichmentLoading = ({ description }: AiEnrichmentLoadingProps) => {
  return (
    <Inline space={3} className={cn('relative w-full overflow-hidden rounded-lg bg-muted p-4')}>
      <p className="text-sm font-medium text-muted-foreground">{description}</p>

      <BorderBeam size={300} duration={3} className="from-[#CC50F2] via-[#EF7DFF] to-[#293CE9]" />
    </Inline>
  );
};
